<template>
  <div class="left-menu">
    <side-button-bar>
      <el-menu
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
        text-color="#634C37"
        active-text-color="#9E5C1D"
        ref="menu"
      >
        <el-submenu
          :index="item.id"
          v-for="item in classification"
          :key="item.id"
          class="submenu"
        >
          <template slot="title">
            <span>{{ item.name }}</span>
          </template>
          <el-tree
            class="tree-class"
            :data="item.children"
            show-checkbox
            default-expand-all
            node-key="id"
            :highlight-current="true"
            :props="defaultProps"
            check-on-click-node
            :expand-on-click-node="false"
            @check="(a, b) => handleCheck(a, b, item.id)"
          >
            <span class="ellipsis" slot-scope="{ node }">
              <span :title="node.label.title">{{ node.label.name }}</span>
            </span>
          </el-tree>
        </el-submenu>
      </el-menu>
    </side-button-bar>
  </div>
</template>

<script>
import SideButtonBar from './SideButtonBar.vue'
export default {
  components: { SideButtonBar },
  name: 'RetrieveLeftMenu',
  props: {
    sideBarInfo: {
      type: Object
    }
  },
  data () {
    return {
      classification: [
        {
          id: '1',
          name: '分类',
          children: []
        },
        { id: '2', name: '馆藏地', children: [] },
        { id: '3', name: '成书朝代', children: [] },
        { id: '4', name: '版本类型', children: [] },
        { id: '5', name: '版本朝代', children: [] },
        { id: '6', name: '著者名称', children: [] }
      ],
      classificationTree: null,
      tempSidebarInfo: null,
      defaultProps: {
        children: 'children', // 设置通过chiledren树形展示节点信息
        label: 'label'
      },
      checkedKeys: {
        sideBarClassify: [],
        sideBarLibrarySite: [],
        sideBarDynasty: [],
        sideBarEdition: [],
        sideBarYear: [],
        sideBarAuthor: []
      }
    } // 通过label设置树形节点文本展示}
  },
  mounted () {
    this.getAllClassification()
    this.$bus.$on('updateSideBarInfo', this.updateSideBarInfo)
  },
  beforeDestroy () {
    this.$bus.$off('updateSideBarInfo', this.updateSideBarInfo)
  },
  methods: {
    handleOpen (key, keyPath) {
      //   console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      //   console.log(key, keyPath)
    },
    updateSideBarInfo (sideBarInfo) {
      if (!this.classificationTree) {
        this.tempSidebarInfo = sideBarInfo
        return
      }
      for (let i = 0; i < this.classification.length; i++) {
        this.classification[i].children = []
      }
      let i = 0
      sideBarInfo['classification'] = this.updateClassificationCount(sideBarInfo['classification'])
      for (let key in sideBarInfo) {
        if (key === 'author') {
          i = 5
        } else if (key === 'editionType') {
          i = 3
        } else if (key === 'editionDynasty') {
          i = 4
        } else if (key === 'library') {
          i = 1
        } else if (key === 'completionDynasty') {
          i = 2
        } else if (key === 'classification') {
          i = 0
        }
        this.classification[i].children = []
        // console.log(key, i)
        for (let keyin in sideBarInfo[key]) {
          //   对于过长的分类名称，截取前10个字符
          let newKeyin = keyin
          if (keyin.length > 7) {
            newKeyin = keyin.substring(0, 7) + '...'
          }
          if (key !== 'classification') {
            newKeyin = newKeyin + ' (' + sideBarInfo[key][keyin] + ')'
          } else {
            newKeyin = newKeyin + ' (' + sideBarInfo[key][keyin].count + ')'
          }
          let title = keyin
          if (key !== 'library') {
            this.classification[i].children.push({
              id: keyin,
              label: { name: newKeyin, title: title }
            })
          } else {
            let keyins = keyin.split('-')
            let realKeyin = keyins[keyins.length - 1]
            let realKeyinName = realKeyin
            if (realKeyin.length > 7) {
              realKeyinName = realKeyin.substring(0, 7) + '...'
            }
            realKeyinName =
              realKeyinName + ' (' + sideBarInfo[key][keyin] + ')'
            this.classification[i].children.push({
              id: realKeyin,
              label: { name: realKeyinName, title: keyin }
            })
          }

          if (key === 'classification') {
            this.classification[i].children[this.classification[i].children.length - 1].children = []
            for (let children of sideBarInfo[key][keyin].children) {
              //   console.log(children)
              let newChildName = children.name
              if (newChildName.length > 7) {
                newChildName = children.name.substring(0, 7) + '...'
              }
              let title = children.name
              this.classification[i].children[this.classification[i].children.length - 1].children.push({
                id: children.name,
                label: {
                  name: newChildName + ' (' + children.count + ')',
                  title: title
                }
              })
            }
          }
        }
      }
      this.openAllMenu()
    },
    handleCheck (data, check, item) {
      console.log(data, check, item)
      //   if (check.checkedKeys.length === 0) {
      //     this.checkedKeys.sideBarClassify = []
      //   }
      //   console.log(data.children)
      if (data.children !== undefined) {
        for (let child of data.children) {
          let data = child
          //   console.log(data)
          if (check.checkedKeys.indexOf(data.id) !== -1) {
            if (item === '1') {
              this.checkedKeys.sideBarClassify.push(data.id)
            } else if (item === '2') {
              this.checkedKeys.sideBarLibrarySite.push(data.id)
            } else if (item === '3') {
              this.checkedKeys.sideBarDynasty.push(data.id)
            } else if (item === '4') {
              this.checkedKeys.sideBarEdition.push(data.id)
            } else if (item === '5') {
              this.checkedKeys.sideBarYear.push(data.id)
            } else if (item === '6') {
              this.checkedKeys.sideBarAuthor.push(data.id)
            }
          } else {
            if (item === '1') {
              this.checkedKeys.sideBarClassify.splice(
                this.checkedKeys.sideBarClassify.indexOf(data.id),
                1
              )
            } else if (item === '2') {
              this.checkedKeys.sideBarLibrarySite.splice(
                this.checkedKeys.sideBarLibrarySite.indexOf(data.id),
                1
              )
            } else if (item === '3') {
              this.checkedKeys.sideBarDynasty.splice(
                this.checkedKeys.sideBarDynasty.indexOf(data.id),
                1
              )
            } else if (item === '4') {
              this.checkedKeys.sideBarEdition.splice(
                this.checkedKeys.sideBarEdition.indexOf(data.id),
                1
              )
            } else if (item === '5') {
              this.checkedKeys.sideBarYear.splice(
                this.checkedKeys.sideBarYear.indexOf(data.id),
                1
              )
            } else if (item === '6') {
              this.checkedKeys.sideBarAuthor.splice(
                this.checkedKeys.sideBarAuthor.indexOf(data.id),
                1
              )
            }
          }
        }
      }
      if (check.checkedKeys.indexOf(data.id) !== -1) {
        if (item === '1') {
          this.checkedKeys.sideBarClassify.push(data.id)
        } else if (item === '2') {
          this.checkedKeys.sideBarLibrarySite.push(data.id)
        } else if (item === '3') {
          this.checkedKeys.sideBarDynasty.push(data.id)
        } else if (item === '4') {
          this.checkedKeys.sideBarEdition.push(data.id)
        } else if (item === '5') {
          this.checkedKeys.sideBarYear.push(data.id)
        } else if (item === '6') {
          this.checkedKeys.sideBarAuthor.push(data.id)
        }
      } else {
        if (item === '1') {
          this.checkedKeys.sideBarClassify.splice(
            this.checkedKeys.sideBarClassify.indexOf(data.id),
            1
          )
        } else if (item === '2') {
          this.checkedKeys.sideBarLibrarySite.splice(
            this.checkedKeys.sideBarLibrarySite.indexOf(data.id),
            1
          )
        } else if (item === '3') {
          this.checkedKeys.sideBarDynasty.splice(
            this.checkedKeys.sideBarDynasty.indexOf(data.id),
            1
          )
        } else if (item === '4') {
          this.checkedKeys.sideBarEdition.splice(
            this.checkedKeys.sideBarEdition.indexOf(data.id),
            1
          )
        } else if (item === '5') {
          this.checkedKeys.sideBarYear.splice(
            this.checkedKeys.sideBarYear.indexOf(data.id),
            1
          )
        } else if (item === '6') {
          this.checkedKeys.sideBarAuthor.splice(
            this.checkedKeys.sideBarAuthor.indexOf(data.id),
            1
          )
        }
      }

      console.log(this.checkedKeys)
      this.$bus.$emit('updateCheckedKeys', this.checkedKeys)
      if (this.$router.currentRoute.path.split('/')[3] === 'introduction') {
        this.$global.searchDTO.sideBarInfo = this.checkedKeys
        this.$global.advancedSearchDTO.sideBarInfo = this.checkedKeys
        this.$global.searchDTO.returnType = 'all'
        this.$global.advancedSearchDTO.returnType = 'all'
        this.$router.push({
          path: '/retrieve/retrieveHome/retrieveResult',
          query: {
            searchText: '',
            fromIntroduce: true,
            exactSearch: 1
          }
        })
      }
    },
    resetSideBar () {
      this.checkedKeys = {
        sideBarClassify: [],
        sideBarLibrarySite: [],
        sideBarDynasty: [],
        sideBarEdition: [],
        sideBarYear: [],
        sideBarAuthor: []
      }
    },
    openAllMenu () {
      for (let i = 0; i < this.classification.length; i++) {
        this.$refs.menu.open(this.classification[i].id)
      }
    },
    getAllClassification () {
      this.$http.get('/retrieve/search/getAllClassification').then(response => {
        if (response.data.status === 200) {
          this.classificationTree = response.data.data
          if (this.tempSidebarInfo) {
            this.updateSideBarInfo(this.tempSidebarInfo)
            this.tempSidebarInfo = null
          }
        }
      }).catch(err => {
        console.error(err)
        this.classificationTree = null
      })
    },
    updateClassificationCount (classificationMap) {
      if (!classificationMap) { return }
      const tempTree = JSON.parse(JSON.stringify(this.classificationTree))
      const newTree = {}
      for (let node of tempTree) {
        this.updateClassificationCountRecursively(node, classificationMap)
        // 移除数量为0的子项
        if (node.children && node.children.length > 0) {
          node.children = node.children.filter(item => item.count > 0)
        }
        newTree[node.name] = node
      }
      // 将列表改为object结构
      return newTree
    },
    updateClassificationCountRecursively (node, classificationMap) {
      if (!node) { return }
      if (node.name in classificationMap) {
        node.count = classificationMap[node.name]
      } else {
        node.count = 0
      }
      if (node.children && node.children.length > 0) {
        for (let i = 0; i < node.children.length; i++) {
          this.updateClassificationCountRecursively(node.children[i], classificationMap)
          node.count += node.children[i].count
        }
      }
    }
  }
}
</script>

<style scoped>
.left-menu {
  width: 220px;
  height: 100%;
  background-color: #ffffff;
}
.img-top {
  width: 220px;
  display: flex;
  align-items: top;
  margin-bottom: 7px;
}
.img-bottom {
  width: 220px;
  position: absolute;
  bottom: 0;
  left: 0;
}
.submenu >>> .el-submenu__title {
  height: 40px;
  font-size: 16px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #634c37;
  text-align: left;
  /* padding:12px 0 0 0 ; */
  line-height: 40px;
  margin-bottom: 2px;
  background-image: url(../assets/images/bookIcons/leftmenu1.png);
}

.submenu >>> .el-tree-node__content:hover {
  background-image: url(../assets/images/bookIcons/leftmenu2.png);
  background-color: "";
}

.submenu >>> .el-icon-arrow-down:before {
  background: url(../assets/images/bookIcons/down.png);
  content: "";
  display: block;
  width: 15px;
  height: 20px;
  font-size: 18px;
  background-size: 15px;
}

.tree-class {
  font-size: 16px !important;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #634c37;
  line-height: 0px;
}

.tree-class >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #9e5c1d;
  border-color: #9e5c1d;
}

.tree-class >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #9e5c1d;
  border-color: #9e5c1d;
}

.tree-class >>> .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #9e5c1d;
}

.tree-class >>> .el-checkbox__input:hover .el-checkbox__inner {
  border-color: #9e5c1d;
}

.tree-class >>> .el-tree-node__content {
  height: 32.4px;
}

.tree-class >>> .el-tree-node__label {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/RetrieveLeftMenu.vue